import { FormAtylBase } from '../../form-atyl-base'

export class AtylLabel extends FormAtylBase<string> {
	controlType = 'label'
	type: string

	constructor(options: {} = {}) {
		super(options)
		this.type = options['type'] || ''
	}
}
